<template>
  <div>
    <Section>
      <SectionHeader :title="$t('apps.payroll.message.general')"/>
      <FormRow>
        <Col className="col-lg-6">
        <Label :text="`${$t('apps.payroll.message.name')} *`" />
        <BaseInput
          v-model="$v.input.name.$model"
          :classNames="[{ 'is-invalid': $v.input.name.$error }]"
          :disabled="disabled"
        />
        </Col>
      </FormRow>
    </Section>

    <Section v-if="input.name">
      <SectionHeader :title="$t('apps.payroll.message.assignemployee')"/>
      <FormRow>
        <Col
          v-if="!employees.length"
          className="col-lg-12"
        >
        <BaseNotFoundData
          :title="$t('apps.payroll.message.notfoundemployeee')"
          :detail="$t('apps.payroll.message.createnewemployee')"
        />
        </Col>
        <Col
          v-else
          className="col-lg-12"
        >
        <BaseAssignItems
          v-model="input.assignIds"
          :items="assignitems"
          :replace="false"
          :colName="8"
          :colValue="4"
          :disabled="disabled"
        />
        </Col>
      </FormRow>
    </Section>

    <BaseFormAction
      v-if="showActionButtons"
      :textCancel="$t('button.cancel')"
      :textSubmit="$t('button.save')"
      :isSubmitted="isSubmitted"
      @onCancel="handleCancel"
      @onSubmit="handleSubmit"
    />
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import _ from 'lodash'

export default {
  props: ['state', 'isSubmitted', 'disabled', 'employees', 'showActionButtons'],

  data () {
    return {
      input: {
        name: null,
        assignIds: [],
      },
      inputOriginal: null,
    }
  },

  validations: {
    input: {
      name: {
        required,
      },
    },
  },

  computed: {
    assignitems () {
      return this.employees.map((item) => {
        const primaryName = (() => {
          let arr = []
          if (item.departmentName) {
            arr.push(item.departmentName)
          }
          if (item.positionName) {
            arr.push(item.positionName)
          }
          return arr.length ? `(${arr.join(', ')})` : null
        })()
        return {
          text: item.name,
          value: item.empId,
          primaryName,
        }
      })
    },
  },

  watch: {
    input: {
      handler: function () {
        this.$emit('update:form', this.input)
      },
      deep: true,
    },
  },

  created () {
    if (this.state) {
      this.setInput(this.state)
    } else {
      this.inputOriginal = _.cloneDeep(this.input)
    }
  },

  methods: {
    handleCancel () {
      if (this.$listeners.onCancel) {
        this.$emit('onCancel')
      } else {
        this.input = _.cloneDeep(this.inputOriginal)
        this.scrollToTop(600)
      }
    },
    handleSubmit () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.scrollToTop(600)
      } else {
        this.$emit('onSubmit', this.input)
      }
    },
    setInput (state) {
      this.input.name = state.name
      this.input.assignIds = state.employees.map((emp) => emp.empId)
      this.inputOriginal = _.cloneDeep(this.input)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/combine/PayrollEmployeeGroupForm.vue